/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramInternalTransactionsUserControllerFindAllQueryResponse,
  TelegramInternalTransactionsUserControllerFindAllQueryParams,
  TelegramInternalTransactionsUserControllerFindAll401,
} from '../types/TelegramInternalTransactionsUserControllerFindAll.ts';

function getTelegramInternalTransactionsUserFindAllUrl() {
  const res = { method: 'GET', url: `/api/user/telegram/internal-transactions` as const };
  return res;
}

/**
 * {@link /api/user/telegram/internal-transactions}
 */
export async function telegramInternalTransactionsUserFindAll(
  params?: TelegramInternalTransactionsUserControllerFindAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramInternalTransactionsUserControllerFindAllQueryResponse,
    ResponseErrorConfig<TelegramInternalTransactionsUserControllerFindAll401>,
    unknown
  >({ method: 'GET', url: getTelegramInternalTransactionsUserFindAllUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
